export const convertImageFileToBase64 = (file?: File) => {
  return new Promise((resolve, reject) => {
    if (!file) {
      return reject;
    }
    var fr = new FileReader();
    fr.onload = () => {
      resolve(fr.result);
    };
    fr.onerror = reject;
    fr.readAsDataURL(file);
  });
};

// simple str url converter into base64
export const urlConvertToBase64 = (input: string): string => {
  try {
    return btoa(input);
  } catch (error) {
    console.error('Invalid input for Base64 conversion', error);
    return '';
  }
};

/**
 * Checks if base64 file is jpeg or jpg
 * @returns boolean
 */
// eslint-disable-next-line no-unused-vars
export const isImageStrJpgJpeg = (str: string) => {
  // TODO: Add logic
  return true;
};
